module.exports = __webpack_public_path__ + "static/media/4.78c339d7.jpg";